import * as React from 'react';
import { useParams } from 'react-router';
import { EventsPageContainer } from './containers';

interface RouterParams {
    eventId: string;
}

export const EventsPage: React.FC = () => {
    const { eventId } = useParams<RouterParams>();
    // eventId may be a numeric id or a uuid — pass through as-is.
    return <EventsPageContainer eventId={eventId} />;
};
